import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

// You would have your image at this path: src/assets/breadcrumb/Course.jpg
import course from '../../assets/breadcrumb/Courses.jpg';

import { FaLandmark, FaGlobeAsia, FaUsers, FaFeatherAlt, FaPenNib } from 'react-icons/fa';
import './Courses.css';

// Data for Arts Courses - Easy to update
const artsCoursesData = [
  {
    id: 1,
    title: "B.A. in History",
    icon: <FaLandmark />,
    description: "Explore the fascinating events, cultures, and civilizations of the past to understand the present and shape the future.",
    keySubjects: ["Ancient Indian History", "Medieval India", "World History", "Modern Indian History"],
    eligibility: "10+2 from any recognized board."
  },
  {
    id: 2,
    title: "B.A. in Political Science",
    icon: <FaUsers />,
    description: "Study the theory and practice of politics, government systems, and international relations to become an informed global citizen.",
    keySubjects: ["Indian Constitution", "Public Administration", "International Relations", "Political Theory"],
    eligibility: "10+2 from any recognized board."
  },
  {
    id: 3,
    title: "B.A. in Sociology",
    icon: <FaUsers />,
    description: "Analyze the structure of society, human social behavior, and the dynamics of social problems and their causes.",
    keySubjects: ["Introduction to Sociology", "Social Problems in India", "Rural Sociology", "Research Methods"],
    eligibility: "10+2 from any recognized board."
  },
  {
    id: 4,
    title: "B.A. in Hindi Literature",
    icon: <FaFeatherAlt />,
    description: "Immerse yourself in the richness of Hindi literature, from ancient poetry to modern prose, and enhance your linguistic skills.",
    keySubjects: ["Adikaal & Madhyakaal Kavya", "Aadhunik Kavya", "Hindi Bhasha & Sahitya", "Katha Sahitya"],
    eligibility: "10+2 with Hindi as a subject."
  },
  {
    id: 5,
    title: "B.A. in Geography",
    icon: <FaGlobeAsia />,
    description: "Understand the Earth's landscapes, environments, and the relationship between people and their surroundings.",
    keySubjects: ["Physical Geography", "Human Geography", "Geography of India", "Cartography & Map Work"],
    eligibility: "10+2 from any recognized board."
  },
];

function Courses() {
  return (
    <>
      <Helmet>
        <title>Courses | SK College</title>
        <meta
          name="description"
          content="Explore Arts courses at SK College including History, Political Science, Sociology, Hindi Literature, English Literature, and Geography."
        />
        <meta
          name="keywords"
          content="SK College Courses, BA History, BA Political Science, BA Sociology, BA Hindi, BA English, BA Geography"
        />
        <link rel="canonical" href="https://skcollegemanaklao.com/courses" />
      </Helmet>

      <div className="courses-of-sk-college-wrapper">
        
        {/* 1. Breadcrumb Header - NOW USES YOUR IMPORTED IMAGE */}
        <div 
          className="courses-of-sk-college-header" 
          style={{ backgroundImage: `url(${course})` }}
        >
          <div className="courses-of-sk-college-header-overlay">
            <h1 className="courses-of-sk-college-title">Our Courses</h1>
            <div className="courses-of-sk-college-breadcrumb">
              <Link to="/">Home</Link>
              <span className="courses-of-sk-college-sep">/</span>
              <span className="courses-of-sk-college-current">Courses</span>
            </div>
          </div>
        </div>

        {/* 2. Main Content Section */}
        <div className="courses-of-sk-college-container">
          {/* Introduction Section */}
          <div className="courses-of-sk-college-intro">
            <h2 className="courses-of-sk-college-section-title">Faculty of Arts</h2>
            <p className="courses-of-sk-college-section-subtitle">
              The Faculty of Arts at SK College is dedicated to fostering critical thinking, creativity, and a deep understanding of human culture and society. Our programs are designed to equip students with the knowledge and skills necessary for a wide range of successful careers and for a lifetime of intellectual exploration.
            </p>
          </div>

          {/* Courses Grid */}
          <div className="courses-of-sk-college-grid">
            {artsCoursesData.map((course) => (
              <div key={course.id} className="courses-of-sk-college-card">
                <div className="courses-of-sk-college-card-header">
                  <div className="courses-of-sk-college-card-icon-wrapper">
                    {course.icon}
                  </div>
                  <h3 className="courses-of-sk-college-card-title">{course.title}</h3>
                </div>
                <p className="courses-of-sk-college-card-desc">{course.description}</p>
                
                <div className="courses-of-sk-college-card-details">
                  <h5>Key Subjects</h5>
                  <ul>
                    {course.keySubjects.map((subject, index) => (
                      <li key={index}>{subject}</li>
                    ))}
                  </ul>
                </div>

                <div className="courses-of-sk-college-card-footer">
                  <p><strong>Eligibility:</strong> {course.eligibility}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Courses;